// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GJf","content":"GJbd","text":"GJah","link":"GJch","buttonWrapper":"GJaa1","button":"GJd3"};